import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import './comfun'
import VueScroller from 'vue-scroller'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// 引入并注册全局组件
import VueClipboard from 'vue-clipboard2'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import vcolorpicker from 'vcolorpicker'
import store from './store/index'
import Print from 'vue-print-nb'
import BreadCrumb from "@/components/common/BreadCrumb"
import './assets/js/system'
import './assets/js/permission'

Vue.use(VueClipboard);
Vue.use(ViewUI);
Vue.use(VueScroller);
Vue.use(vcolorpicker);
Vue.use(Viewer)
Vue.use(Print)
Vue.component('BreadCrumb', BreadCrumb)
// Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  if (to.path.indexOf('/admin/store/') != -1) {
    localStorage.setItem('store_type', 0)
  }
  if (to.path.indexOf('/admin/login') != -1) {
    localStorage.setItem('store_type', 1)
  }
  if (to.path.indexOf('/admin/clinic/login/') != -1) {
    localStorage.setItem('store_type', 3)
  }
  if (to.path.indexOf('/admin/mechanism/login') != -1) {
    localStorage.setItem('store_type', 4)
  }
  if (to.meta.title) {
    const title = localStorage.getItem('station_title')
    document.title = title ? title + '-' + to.meta.title : to.meta.title
  }
  next();
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js